import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
//import './App.css';
import firebase from './../Firestore'

//import config from 'react-global-configuration';

//import CategoriaNombre from '../components/Admin/CategoriaNombre'
//import Precio from '../components/Admin/Precio'
//import Imagen from './Imagen'
import NavBar from './NavBar'
import AdminEstadoPedido from './AdminEstadoPedido'
//import MarcoItem from '../Global/MarcoItem'

class Pedidos extends Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection("pedido").where("enProceso", "==", true).orderBy("fecha", "desc");


    this.unsubscribe = null;

    this.state = {
      pedidos: [],
      cat: [],
      adicionalDetalle : [],
      productoDetalle: []
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    
    const pedidos = [];
    querySnapshot.forEach((doc) => {
      //const { nombre, imagen, orden, seFracciona, diseno } = doc.data();
      pedidos.push({
        key: doc.id,
        doc // DocumentSnapshot
      });
    });
    this.setState({
      pedidos
   });
  }


  componentWillMount(){
  let currentComponent = this;
    let db = firebase.firestore()
    db.collection("producto").where("enStock", "==", true)
        .get()
        .then(function(querySnapshot) {
          var data = querySnapshot.docs.map(function (documentSnapshot) {
            return {id: documentSnapshot.id, data: documentSnapshot.data()};
          });

          currentComponent.setState({productoDetalle: data})

        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });

    // categorias

    db.collection("categoria").orderBy("orden", "asc").get().then((snapShots) => {
        this.setState(
          {
            cat: snapShots.docs.map(doc => {
              return {
                "nombre": doc.data().nombre,
                "imagen": doc.data().imagen,
                "seFracciona": doc.data().seFracciona,
                "diseno": doc.data().diseno,
                "id": doc.id}
            })
          }
        );

      });

      // adicionales
    db.collection("adicionales")
        .get()
        .then(function(querySnapshot) {
          var data = querySnapshot.docs.map(function (documentSnapshot) {
            return {id: documentSnapshot.id, data: documentSnapshot.data()};
          });

          currentComponent.setState({adicionalDetalle: data})

        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });
  }


  async componentDidMount() {
    this.unsubscribe = await this.ref.onSnapshot(this.onCollectionUpdate);
  }


  render() {
    return (
      <div className="bg-danger">
      <NavBar history={this.props.history} />
        <div className="d-print-none pl-3">
          <h3>PEDIDOS EN PROCESO</h3>
          <span className="font-weight-lighter">Al imprimir los pedidos solo aparecerán aquellos que tengan seleccionado el iconito <i className="fas fa-print" />.</span>
          </div>

        <div className="d-flex flex-wrap d-print-inline-flex">
          {this.state.pedidos.map((pedido, index, arr) =>

            <div className="col-sm" key={pedido.key}>

                <AdminEstadoPedido pedidoId={pedido.key} productoDetalle={this.state.productoDetalle} cat={this.state.cat} adicionalDetalle={this.state.adicionalDetalle}/>

            </div>
          )}
        </div>

      </div>


    );
  }
}

export default Pedidos;
